<template>
  <section>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <b-modal v-model="show" :width="800" scroll="keep" :on-cancel="closeModal">
      <div class="modal-widget" id="#create_device_cotainer">
        <div class="modal-title">
          <h2 class="title">
            {{
              device.editing ? "Editar dispositivo " : "Agregar dispositivo a "
            }}
            <span class="device-name">{{ device.deviceName }}</span>
          </h2>
        </div>
        <div class="modal-body">
          <div class="grid-columns">
            <div class="column">
              <b-field label="Tipo de dispositivo *">
                <b-select
                    placeholder="Tipo de disposiitvo"
                    expanded
                    v-model="deviceType"
                    name="deviceType"
                    :disabled="editing">
                  <option
                      v-for="option in device.deviceTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code">
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <b-field label="Nombre de dispositivo  *">
                <b-input
                    placeholder="Nombre de dispositivo"
                    type="text"
                    name="deviceName"
                    v-model="deviceName"
                />
              </b-field>
            </div>
            <div class="column">
              <b-field label="Estado *">
                <b-select
                    placeholder="Estado"
                    expanded
                    v-model="status"
                    name="status"
                >
                  <option
                      v-for="option in device.statusList"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.description }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div
                class="column"
                v-for="(field, index) in dinamycFields"
                :key="field.key"
                :id="field.key"
            >
              <DinamycField
                  v-bind:field="field"
                  v-bind:index="index"
                  v-bind:dynamicFields="dinamycFields"
                  v-bind:dinamycValueFields="dinamycValueFields"
                  @onChange="onChangeValue"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="columns">
            <div class="column text-right">
              <vs-button
                  color="danger"
                  type="filled"
                  class="pl-5 pr-5"
                  icon="close"
                  @click="closeModal"
              >Cancelar
              </vs-button
              >
              <vs-button
                  color="success"
                  class="ml-3 pl-5 pr-5"
                  :icon="device.editing ? 'edit' : 'add'"
                  type="filled"
                  @click="addDevice"
                  :disabled="validate()"
              >
                {{ device.editing ? "Actualizar" : "Agregar" }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import {ROUTES} from "@/global/api_routes";
import {validator} from "@/global/validator";
import DinamycField from "./DinamycField.vue";

export default {
  components: {DinamycField},
  props: {
    device: {
      type: Object,
      default: {deviceTypes: []},
    },
  },
  data: () => ({
    show: true,
    isLoading: false,
    deviceType: null,
    deviceName: null,
    status: null,
    dinamycFields: [],
    dinamycValueFields: [],
    editing: false,
  }),
  watch: {
    deviceType: function (id, prev) {
      if (
          (Array.isArray(this.device.dinamycValueFields) &&
              this.device.dinamycValueFields.length > 0) ||
          (Object.keys(this.device.dinamycValueFields).length > 0 &&
              this.device.editing)
      ) {
        this.dinamycFields = this.device.dinamycFields;
        this.dinamycValueFields = this.device.dinamycValueFields;
        this.editing = true;
        return;
      }
      if (!id) {
        return;
      }
      this.getDeviceTypesFields(id);
    },
  },
  mounted() {
    if (this.device.editing) {
      this.deviceName = this.device.deviceName;
      this.deviceType = this.device.deviceType;
      this.status = this.device.status;
    }
  },
  methods: {
    onChangeValue(change) {
      const obj = {...this.dinamycValueFields};
      obj[change.key] = change.value;
      this.dinamycValueFields = obj;
    },
    addDevice() {
      this.$emit("pushSubItemDevice", {
        device: this.device,
        subdevice: {
          deviceName: this.deviceName,
          deviceType: this.deviceType,
          status: this.status,
          statusList: this.device.statusList,
          deviceTypes: this.device.deviceTypes,
          dinamycFields: this.dinamycFields,
          dinamycValueFields: this.dinamycValueFields,
        },
      });
    },
    closeModal() {
      this.$emit("closeModal");
    },
    validate() {
      const rules = [
        {field: "deviceType"},
        {field: "deviceName"},
        {field: "status"},
      ];
      const extraValues = {};
      this.dinamycFields.forEach((field, index) => {
        if (field.required) {
          rules.push({field: field.key});
          extraValues[field.key] = this.dinamycValueFields[field.key];
        }
      });
      const {result, errors} = validator({...this, ...extraValues}, rules);
      return !result;
    },
    getDeviceTypesFields(id) {
      this.isLoading = true;
      this.dinamycFields = [];
      this.dinamycValueFields = {};
      this.$http
          .get(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICE_TYPE_FIELDS, {
            params: {
              deviceTypeId: id,
            }
          })
          .then(({data}) => {
            if (data.code < 1 || !data.info) {
              this.device.dinamycFields = [];
              this.device.dinamycValueFields = [];
              return;
            }
            this.dinamycFields = JSON.parse(data.info.fields);
            this.dinamycFields.forEach((field) => {
              this.dinamycValueFields[field.key] = null;
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
  },
};
</script>
<style scoped>
.device-name {
  color: #3cbea6;
}
</style>
